<section class="contenido" style=" margin-top: 100px;">
  <div class="conten-cont">
    <div class="container-1" style="justify-content: center; align-items: flex-start; position: relative;">
      <div class="banner-container"
        style="align-items: center;width: auto;height: auto; position: relative; display: block; padding: 2em">
        <img src="/assets/img/talleres-expo/Landing-page-Talleres-Cricut-02-Banner.webp" alt=""
          style="width: 100%; height: auto;">
      </div>
      <div class="banner-container">
        <div class="texto-sobre-imagen" style="text-align: center;">
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7220-taller-stickers-con-cricut-para-tu-negocioexpo-mayo-2025"><img
              class="img-taller" src="/assets/img/talleres-expo/Landing-page-Talleres-Cricut-03.webp" alt=""
              style="width: 93%;"></a>
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7220-taller-stickers-con-cricut-para-tu-negocioexpo-mayo-2025"><img
              class="boton-me-interesa" src="/assets/img/talleres-expo/Boton-Me-interesa-15.webp" alt=""
              style="width: 33%;"></a>
        </div>
        <div class="texto-sobre-imagen" style="text-align: center;">
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7221-taller-integra-la-sublimaci%C3%B3n-a-tu-emprendimientoexpo-mayo-2025"><img
              class="img-taller" src="/assets/img/talleres-expo/Landing-page-Talleres-Cricut-04.webp" alt=""
              style="width: 93%;"></a>
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7221-taller-integra-la-sublimaci%C3%B3n-a-tu-emprendimientoexpo-mayo-2025"><img
              class="boton-me-interesa" src="/assets/img/talleres-expo/Boton-Me-interesa-15.webp" alt=""
              style="width: 33%;"></a>
        </div>
      </div>
      <div class="banner-container">
        <div class="texto-sobre-imagen" style="text-align: center;">
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7222-taller-vu%C3%A9lvete-un-experto-en-vinil-en-capas-y-emprender--expo-mayo-2025"><img
              class="img-taller" src="/assets/img/talleres-expo/Landing-page-Talleres-Cricut-05.webp" alt=""
              style="width: 93%;"></a>
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7222-taller-vu%C3%A9lvete-un-experto-en-vinil-en-capas-y-emprender--expo-mayo-2025"><img
              class="boton-me-interesa" src="/assets/img/talleres-expo/Boton-Me-interesa-15.webp" alt=""
              style="width: 33%;"></a>
        </div>
        <div class="texto-sobre-imagen" style="text-align: center;">
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7223-taller-grabado-en-acr%C3%ADlico-con-cricut-para-tu-negocio--expo-mayo-2025"><img
              class="img-taller" src="/assets/img/talleres-expo/Landing-page-Talleres-Cricut-06.webp" alt=""
              style="width: 93%;"></a>
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7223-taller-grabado-en-acr%C3%ADlico-con-cricut-para-tu-negocio--expo-mayo-2025"><img
              class="boton-me-interesa" src="/assets/img/talleres-expo/Boton-Me-interesa-15.webp" alt=""
              style="width: 33%;"></a>
        </div>
      </div>
      <div class="banner-container">
        <div class="texto-sobre-imagen" style="text-align: center;">
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7224-taller-dise%C3%B1a-y-vende-papeler%C3%ADa-socialexpo-mayo-2025"><img
              class="img-taller" src="/assets/img/talleres-expo/Landing-page-Talleres-Cricut-07.webp" alt=""
              style="width: 93%;"></a>
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7224-taller-dise%C3%B1a-y-vende-papeler%C3%ADa-socialexpo-mayo-2025"><img
              class="boton-me-interesa" src="/assets/img/talleres-expo/Boton-Me-interesa-15.webp" alt=""
              style="width: 33%;"></a>
        </div>
        <div class="texto-sobre-imagen" style="text-align: center;">
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7225-taller-explora-las-herramientas-especiales-de-cricut-maker-para-tu-emprendimientoexpo-mayo-2025"><img
              class="img-taller" src="/assets/img/talleres-expo/Landing-page-Talleres-Cricut-08.webp" alt=""
              style="width: 93%;"></a>
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7225-taller-explora-las-herramientas-especiales-de-cricut-maker-para-tu-emprendimientoexpo-mayo-2025"><img
              class="boton-me-interesa" src="/assets/img/talleres-expo/Boton-Me-interesa-15.webp" alt=""
              style="width: 33%;"></a>
        </div>
      </div>
      <div class="banner-container">
        <div class="texto-sobre-imagen" style="text-align: center;">
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7226-taller-gorras-originales-con-vinil-textil-en-capasexpo-mayo-2025"><img
              class="img-taller" src="/assets/img/talleres-expo/Landing-page-Talleres-Cricut-09.webp" alt=""
              style="width: 93%;"></a>
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7226-taller-gorras-originales-con-vinil-textil-en-capasexpo-mayo-2025"><img
              class="boton-me-interesa" src="/assets/img/talleres-expo/Boton-Me-interesa-15.webp" alt=""
              style="width: 33%;"></a>
        </div>
        <div class="texto-sobre-imagen" style="text-align: center;">
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7227-taller-t%C3%A9cnicas-de-estampado-para-tu-negocioexpo-mayo-2025"><img
              class="img-taller" src="/assets/img/talleres-expo/Landing-page-Talleres-Cricut-10.webp" alt=""
              style="width: 93%;"></a>
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7227-taller-t%C3%A9cnicas-de-estampado-para-tu-negocioexpo-mayo-2025"><img
              class="boton-me-interesa" src="/assets/img/talleres-expo/Boton-Me-interesa-15.webp" alt=""
              style="width: 33%;"></a>
        </div>
      </div>
      <div class="banner-container">
        <div class="texto-sobre-imagen" style="text-align: center;">
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7228-taller-llaveros-inteligentes-el-giro-digital-que-necesita-tu-negocioexpo-mayo-2025"><img
              class="img-taller" src="/assets/img/talleres-expo/Landing-page-Talleres-Cricut-11.webp" alt=""
              style="width: 93%;"></a>
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7228-taller-llaveros-inteligentes-el-giro-digital-que-necesita-tu-negocioexpo-mayo-2025"><img
              class="boton-me-interesa" src="/assets/img/talleres-expo/Boton-Me-interesa-15.webp" alt=""
              style="width: 33%;"></a>
        </div>
        <div class="texto-sobre-imagen" style="text-align: center;">
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7229-taller-dise%C3%B1a-y-vende-papeler%C3%ADa-socialexpo-mayo-2025"><img
              class="img-taller" src="/assets/img/talleres-expo/Landing-page-Talleres-Cricut-12.webp" alt=""
              style="width: 93%;"></a>
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7229-taller-dise%C3%B1a-y-vende-papeler%C3%ADa-socialexpo-mayo-2025"><img
              class="boton-me-interesa" src="/assets/img/talleres-expo/Boton-Me-interesa-15.webp" alt=""
              style="width: 33%;"></a>
        </div>
      </div>
      <div class="banner-container">
        <div class="texto-sobre-imagen" style="text-align: center;">
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7230-taller-crea-stickers-original-para-crear-o-complementar-tu-negocioexpo-mayo-2025"><img
              class="img-taller" src="/assets/img/talleres-expo/Landing-page-Talleres-Cricut-13.webp" alt=""
              style="width: 93%;"></a>
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7230-taller-crea-stickers-original-para-crear-o-complementar-tu-negocioexpo-mayo-2025"><img
              class="boton-me-interesa" src="/assets/img/talleres-expo/Boton-Me-interesa-15.webp" alt=""
              style="width: 33%;"></a>
        </div>
        <div class="texto-sobre-imagen" style="text-align: center;">
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7231-taller-tazas-divertidas-para-peque%C3%B1os-creadoresexpo-mayo-2025"><img
              class="img-taller" src="/assets/img/talleres-expo/Landing-page-Talleres-Cricut-14.webp" alt=""
              style="width: 93%;"></a>
          <a style="display: flex; justify-content: center;"
            href="https://lideart.com.mx/paquetes/7231-taller-tazas-divertidas-para-peque%C3%B1os-creadoresexpo-mayo-2025"><img
              class="boton-me-interesa" src="/assets/img/talleres-expo/Boton-Me-interesa-15.webp" alt=""
              style="width: 33%;"></a>
        </div>
      </div>
    </div>
  </div>
</section>